import { Form } from "antd";
import { FormContainer } from "./styles";
import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useState,
  useRef,
} from "react";
import { staticFields } from "@/util/common_variable";
import { StyledGridRow } from "@/common/styles";
import DynamicForm from "@/common/DynamicForm";
import { PERSON } from "./Personal";
import { useDispatch, useSelector } from "react-redux";
import dayjs from "dayjs";
import { setBookings } from "@/slices/bookingsSlice";
import { debounce, hasCheckSecurity, isNonEmptyVariable } from "@/util/common_function";

const ArrestBook = forwardRef(
  ({ person = PERSON.INMATE, arrestbookFormRef, startingPoint }) => {
    const dispatch = useDispatch();
    const { bookings, bookingsFieldsEnabled } = useSelector(
      (state) => state?.bookings
    );
    const [form] = Form.useForm();
    const [arrestForm, setArrestInfoForm] = useState(null);
    const isFirstTime = useRef(true);
    const fullSearch = useSelector(state => state.fullSearch);

    useEffect(() => {
      if (bookings != null) {
        const ar = bookings?.arrestReports?.[0];

        setArrestInfoForm(() => ({
          ...ar,
          incarcerationDateTime: isNonEmptyVariable(ar?.incarcerationDateTime)
            ? dayjs(ar?.incarcerationDateTime)
            : null,

          arrestDateTime: bookings?.arrestReports?.[0]?.arrestDate
            ? dayjs(
              (isNonEmptyVariable(bookings?.arrestReports?.[0]?.arrestDate)
                ? bookings?.arrestReports?.[0]?.arrestDate
                : "") +
              " " +
              (isNonEmptyVariable(bookings?.arrestReports?.[0]?.arrestTime)
                ? bookings?.arrestReports?.[0]?.arrestTime
                : "")
            )
            : fullSearch ? "" : dayjs(),
          towingCompany:
            bookings?.arrestReports?.[0]?.arrestReportsExtra?.[0]
              ?.towingCompany,
          intakeWarCheckDate: bookings?.arrestReports?.[0]
            ?.arrestReportsExtra?.[0]?.intakeWarCheckDate
            ? dayjs(
              bookings?.arrestReports?.[0]?.arrestReportsExtra?.[0]
                ?.intakeWarCheckDate
            )
            : null,

          inmateTypeId:
            isNonEmptyVariable(bookings?.arrestReports?.[0]?.inmateTypeId)
            ? bookings?.arrestReports?.[0]?.inmateTypeId
            : null, // default value
        }));
      } else {
        setArrestInfoForm(null);
      }
    }, [bookings]);

    // useEffect(() => {
    //   if (arrestForm && isFirstTime.current) {
    //     if (arrestForm !== null) {
    //       form.setFieldsValue(arrestForm);
    //     } else {
    //       form.resetFields();
    //     }
    //     isFirstTime.current = false
    //   }
    // }, [arrestForm]);

    useEffect(() => {
      if (arrestForm !== null) {
        form.setFieldsValue(arrestForm);
        console.log("✅ form.setFieldsValue called with:", arrestForm);
      } else {
        form.resetFields();
        console.log("Form reset (arrestForm is null)");
      }
    }, [arrestForm]);


    // Expose form methods to parent
    useImperativeHandle(arrestbookFormRef, () => ({
      submitForm: () => form.submit(),
      resetForm: () => form.resetFields(),
      getFormValues: () => form.getFieldsValue(),
      getFieldsError: () => form.getFieldsError(),
      isFieldsValidating: () => form.isFieldsValidating(),
      validateFields: () => form.validateFields(),
    }));

    const updateForm = (data) => {
      dispatch(
        setBookings({
          arrestReports: [
            {
              ...bookings?.arrestReports?.[0],
              ...data,

              arrestReportsExtra: [
                {
                  ...bookings?.arrestReports?.[0]?.arrestReportsExtra?.[0],
                  towingCompany: data?.towingCompany || null,
                  intakeWarCheckDate: data?.intakeWarCheckDate || null,
                },
              ],
            },
          ],
        })
      );
    };

    const dataModify = debounce(() => {
      const values = form.getFieldsValue();

      const data = {
        ...values,
        arrestDate: values?.arrestDateTime
          ? dayjs(values?.arrestDateTime)?.format("MM/DD/YYYY")
          : null,
        arrestTime: values?.arrestDateTime
          ? dayjs(values?.arrestDateTime)?.format("HH:mm")
          : null,
        intakeWarCheckDate: values?.intakeWarCheckDate
          ? dayjs(values?.intakeWarCheckDate)?.format("MM/DD/YYYY")
          : null,
      };

      delete data?.arrestDateTime;

      updateForm(data);
    }, 800);

    return (
      <FormContainer>
        <Form
          form={form}
          initialValues={arrestForm}
          disabled={!bookingsFieldsEnabled}
          onFieldsChange={() => {
            dataModify();
          }}
        >
          <StyledGridRow gutter={[16]}>
            {staticFields?.arrest_book_info[person]?.map((sf, index) => {
              let view = hasCheckSecurity("Functionality", "field", "VIEW", "", "", "Bio", sf.columnName, startingPoint)
              let edit = hasCheckSecurity("Functionality", "field", "MODIFY", "", "", "Bio", sf.columnName, startingPoint)
              return (
                <DynamicForm
                  formAttributes={sf}
                  person={person}
                  key={index}
                  form={form}
                  bookingsFieldsEnabled={bookingsFieldsEnabled}
                  view={view}
                  edit={edit}
                  fullSearch={fullSearch}
                />
              );
            })}
          </StyledGridRow>
        </Form>
      </FormContainer>
    );
  }
);

export default ArrestBook;
